import { render, staticRenderFns } from "./WorkOrdersBalance.vue?vue&type=template&id=5a00fae8&"
import script from "./WorkOrdersBalance.vue?vue&type=script&lang=js&"
export * from "./WorkOrdersBalance.vue?vue&type=script&lang=js&"
import style0 from "./WorkOrdersBalance.vue?vue&type=style&index=0&id=5a00fae8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports